module.exports = __webpack_public_path__ + "img/rk.bd3e4482.png";